import { WindowProxy } from '@sm360/widget-commons-core-services';

class StripeAPIService {
    createToken(cardInfo, contactInfo, stripeResponseHandler) {
        const windowProxy = WindowProxy.get();

        if (windowProxy) {
            windowProxy.Stripe.card.createToken(
                {
                    number: cardInfo.cardNumber,
                    cvc: cardInfo.cvc,
                    exp_year: cardInfo.expiringYear,
                    exp_month: cardInfo.expiringMonth,
                    name: `${contactInfo.firstname} ${contactInfo.lastname}`,
                    address_line1: contactInfo.address,
                    address_city: contactInfo.city,
                    address_state: contactInfo.province,
                    address_zip: contactInfo.postalCode,
                },
                stripeResponseHandler
            );
        }
    }
}

export default new StripeAPIService();



// WEBPACK FOOTER //
// ./src/services/StripeAPIService/StripeAPIService.js